import { useMutation } from '@tanstack/react-query';
import updateUser from 'api/user/updateUser';
import useUser from 'hooks/useUser';
import { useState } from 'react';

interface UseModelClearParams {
  onModelClear: () => void;
}

const useModelClear = ({ onModelClear }: UseModelClearParams) => {
  const [checked, setChecked] = useState(false);
  const { data: userData, update } = useUser();
  const { mutate: userMutate } = useMutation({
    mutationFn: updateUser,
    onSuccess: (_, { confirm }) => {
      update({
        confirm,
      });
    },
  });

  const handleCheckboxChange = (event: React.FormEvent<HTMLInputElement>) => {
    setChecked(event.currentTarget.checked);
  };

  const handleConfirm = () => {
    if (checked) {
      userMutate({
        confirm: {
          ...userData?.confirm,
          modelClear: true,
        },
      });
    }
    onModelClear();
  };

  return {
    checked,
    onCheckboxChange: handleCheckboxChange,
    onConfirm: handleConfirm,
  };
};

export default useModelClear;
